import './style.scss';

export type LoadingProps = {};

export const Loading: React.FC<LoadingProps> = (props: LoadingProps) => {
  return (
    <>
      <svg className="spinner" width="65" height="65" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle className="path" fill="none" stroke-width="5" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
      </svg>
    </>
  );
};

export enum LoadingSize {
  Small = '10rem',
  Medium = '30rem',
}

export type LoadingContainerProps = {
  isLoading: boolean;
  children: React.ReactNode;
  size?: LoadingSize;
};

export const LoadingContainer: React.FC<LoadingContainerProps> = (props: LoadingContainerProps) => {
  return (
    <>
      {props.isLoading ? (
        <div className="loadingWrapper" style={{ height: props.size }}>
          <Loading />
        </div>
      ) : (
        <>{props.children}</>
      )}
    </>
  );
};
